import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import { DraggableCardBody, Container } from './draggableCard';

const SkillCard = ({ category }) => {
  const [activeIcon, setActiveIcon] = useState(null);

  const handleIconClick = (index) => {
    setActiveIcon(activeIcon === index ? null : index);
  };

  const handleIconMouseLeave = () => {
    setActiveIcon(null);
  };

  return (
    <Container className="w-full max-w-sm h-full">
      <DraggableCardBody>
        <div className="bg-white dark:bg-neutral-700 rounded-lg p-6 h-full">
          <h3 className="text-2xl font-bold text-center text-neutral-800 dark:text-neutral-200 mb-6">
            {category.title}
          </h3>
          <div className="grid grid-cols-4 gap-4 min-h-[200px] items-center">
            {category.icons.map((item, iconIdx) => {
              const IconComponent = item.icon;
              return (
                <div
                  key={iconIdx}
                  className="relative flex flex-col items-center justify-center group cursor-pointer"
                  onClick={() => handleIconClick(iconIdx)}
                  onMouseLeave={handleIconMouseLeave}
                >
                  <div className="p-2 transition-transform duration-300 group-hover:-translate-y-2 glitter-on-hover">
                    {item.isCustom ? (
                      <IconComponent className="w-10 h-10" />
                    ) : (
                      <Icon icon={item.icon} className="w-10 h-10" />
                    )}
                  </div>
                  <span
                    className={`absolute -bottom-8 z-50 px-3 py-1 text-xs font-medium text-white bg-neutral-900 rounded-md whitespace-nowrap pointer-events-none transition-opacity duration-300 ${activeIcon === iconIdx ? 'opacity-100' : 'opacity-0'} group-hover:opacity-100`}
                  >
                    {item.name}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </DraggableCardBody>
    </Container>
  );
};

export default SkillCard;